export const DEFAULT_COUNTRY_UAE = 'AE';
export const DEFAULT_COUNTRY_KSA = 'SA';
export const EMPTY_CITY_STRING = 'Emirates';

export default DEFAULT_COUNTRY_UAE;
